import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';

import { HAS_WINDOW } from '@eb/feature-detection';
import { onClickOutsideHOC } from '@eb/eds-utils';

import { getLocationInfo } from '../../../../../SearchApp/utils/venue';
import { EnhancedEventCard as EventCard } from '@eb/eds-event-card';
import { EVENT_PROPTYPES } from '../../../../../constants';

import './InteractiveMapMarkerTooltipDesktop.scss';

const DEFAULT_TOP_OFFSET = 55;

export class InteractiveMapMarkerTooltipDesktop extends React.PureComponent {
    static propTypes = {
        selectedEvents: PropTypes.arrayOf(PropTypes.shape(EVENT_PROPTYPES)),
        parentIsFixed: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
        onSaveEvent: PropTypes.func,
        onClick: PropTypes.func,
        // eslint-disable-next-line react/forbid-prop-types
        markerRef: PropTypes.object,
    };

    static defaultProps = {
        onClick: noop,
    };

    _getMapWindowBounds() {
        const { markerRef, parentIsFixed } = this.props;

        let left = 0;

        let top = 0;

        let topOffset = HAS_WINDOW ? window.scrollY : 0;

        if (markerRef) {
            const rect = markerRef.getBoundingClientRect();

            left = rect.left;
            top = rect.top;
        }

        if (parentIsFixed) {
            topOffset = DEFAULT_TOP_OFFSET;
        }

        top += topOffset;

        return { top, left };
    }

    render() {
        const {
            selectedEvents,
            parentIsFixed,
            isAuthenticated,
            onSaveEvent,
            onClick,
        } = this.props;

        const { left, top } = this._getMapWindowBounds();

        const containerClasses = classNames(
            'interactive-map-marker__tooltip-container',
            {
                'interactive-map-marker__tooltip-container--more-than-one-card':
                    selectedEvents.length > 1,
            },
        );
        const tooltipClasses = classNames('interactive-map-marker__tooltip', {
            'interactive-map-marker__tooltip--more-than-one-card':
                selectedEvents.length > 1,
        });
        const tooltipArrowClasses = classNames(
            'interactive-map-marker__tooltip-arrow',
            {
                'interactive-map-marker__tooltip-arrow--more-than-one-card':
                    selectedEvents.length > 1,
            },
        );

        const eventCards = selectedEvents.map(
            ({ venueName, venueAddress, id, ...restProps }) => (
                <EventCard
                    {...restProps}
                    id={id}
                    key={id}
                    locationInfo={getLocationInfo(venueName, venueAddress)}
                    onSaveEvent={onSaveEvent}
                    onClick={onClick.bind(null, id)}
                    isAuthenticated={isAuthenticated}
                    type="list"
                    style="mini"
                    imageStyle="fixed"
                />
            ),
        );

        return (
            <div
                className={containerClasses}
                style={{
                    left,
                    top,
                    display: selectedEvents.length ? 'block' : 'none',
                    position: parentIsFixed ? 'fixed' : 'absolute',
                }}
            >
                <div className={tooltipClasses}>{eventCards}</div>
                <div className={tooltipArrowClasses} />
            </div>
        );
    }
}

export default onClickOutsideHOC(InteractiveMapMarkerTooltipDesktop);
